import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProductosRoutingModule } from "././productos-routing.module";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { MaterialModule } from "../../../components/material/material.module";
import { NgxPermissionsModule } from "ngx-permissions";
import { TipoIncidenciaModule } from "../../../forms/incidencias/tipos-incidencia/tipo-incidencia.module";
import { ProductoModule } from "../../../forms/productos/producto.module";
import { ProductosComponent } from "./productos.component";
import { TipoProductoModule } from "../../../forms/productos/tipos-producto/tipo-producto.module";
import { AccesorioModule } from "../../../forms/productos/accesorios/accesorio.module";
import { CaracteristicaModule } from "../../../forms/productos/caracteristicas/caracteristica.module";
import { AccesoriosComponent } from "./accesorios/accesorios.component";
import { VolverModule } from "../../../components/volver/volver.module";
import { TiposProductoComponent } from "./tipos-producto/tipos-producto.component";
import { CaracteristicasComponent } from "./caracteristicas/caracteristicas.component";
import { TipoProductoCategoriasComponent } from './tipo-producto-categorias/tipo-producto-categorias.component';
import { TipoProductoCategoriaModule } from "../../../forms/productos/tipo-producto-categorias/tipo-producto-categoria.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ProductosRoutingModule,
        TipoIncidenciaModule,
        BotonToggleModule,
        MaterialModule,
        ProductoModule,
        TipoProductoModule,
        TipoProductoCategoriaModule,
        AccesorioModule,
        CaracteristicaModule,
        VolverModule,
    ],
    declarations: [
        ProductosComponent,
        TiposProductoComponent,
        AccesoriosComponent,
        CaracteristicasComponent,
        TipoProductoCategoriasComponent,
    ],
    providers: [
    ],
    entryComponents: [
    ]
})
export class ProductosModule { }